import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {setJwtToken} from "../redux/auth";
import useApi from "../api/useApi";
import {useAppDispatch} from "../hooks";

export const useRegisterCommand = (): ICommand => {
  const messages = useMessageLogic()
  const api = useApi()
  const dispatch = useAppDispatch()

  return {
    help(): string {
      return '- register [USERNAME]/[PASSWORD]\t:: register with a username and password';
    },

    async process(msg: string): Promise<void> {
      const creds = msg.substring('register'.length).trim();
      const [username, password] = creds.split('/');

      if (!username || !password) {
        messages.addErrorMessage("format: register username/password")
      } else {
        try {
          const response = await api.users.register(username, password);
          console.log('register', response);
          dispatch(setJwtToken(response.jwtToken))
          messages.addSuccessMessage('successfully registered as ' + username)
        } catch (e: any) {
          messages.addErrorMessage("failed to register: " + e)
        }
      }
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim().startsWith('register')
    }
  };
}